<template>
  <div class="add-content-box">
    <el-dialog :title="title" :visible.sync="dialogVisible" width="400px" :before-close="handleClose" :close-on-click-modal="false">
      <el-form ref="form" :model="params" :rules="rules" label-width="130px">
        <el-form-item label="机器人类型:" prop="robotType">
          <el-select v-model="params.robotType" size="small" clearable placeholder="请选择机器人类型">
            <el-option v-for="item in type" :value="item.value" :label="item.label" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="需要发表的内容:" prop="content">
          <el-input v-model="params.content" size="small" placeholder="请输入发表的内容"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="submitForm('form')" :loading="flag">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from '@/api'
export default {
  data() {
    return {
      title: '',
      flag: false,
      id: '',
      dialogVisible: false,
      type: [
        {
          label: '评论机器人',
          value: 'COMMENT'
        },
        // {
        //   label: '影院机器人',
        //   value: 'FILM'
        // }
      ],
      rules: {
        robotType: [
          { required: true, message: '请选择机器人类型', trigger: 'change' },
        ],
        content: [
          {
            required: true, message: '请输入需要发表的内容', trigger: 'blur'
          }
        ]
      },
      params: {
        robotType: '',
        content: ''
      },
    }
  },
  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true
          if (this.title === '新增内容') {
            this.addContent()
          }
        }
      });
    },
    // 新增内容
    addContent() {
      API.addContent(this.params).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '新增成功',
            type: 'success'
          });
          this.$emit('handlerContent')
        } else {
          this.$message.error('新增失败')
        }
        this.handleClose();
        this.flag = false
      }).catch(() => {
        this.handleClose();
        this.flag = false
      })
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        robotType: '',
        content: ''
      }
    },
    open(type) {
      this.dialogVisible = true
      if (type === 'add') {
        this.title = '新增内容'
      } 
    }
  }
}
</script>
<style scoped>
.el-input {
  width: 220px;
}
</style>